// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-primary.disabled {\n    opacity: 0.6; \n    pointer-events: none; \n  }\n  ", "",{"version":3,"sources":["webpack://src/Containers/ARC_Reconciliation/Sales/GSTR-1_Repository/App.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,oBAAoB;EACtB","sourcesContent":[".button-primary.disabled {\n    opacity: 0.6; \n    pointer-events: none; \n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
